export const GET_INSIGHT='GET_INSIGHT'
export const GET_TOPIC='GET_TOPIC'